import { render } from "./Statistic.vue?vue&type=template&id=1ef4c962&ts=true"
import script from "./Statistic.vue?vue&type=script&lang=ts"
export * from "./Statistic.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__